import TransactionDetails from "../Components/TransactionDetails";

function Show() {
  return (
    <div>
      <h2>Transaction Details</h2>
      <TransactionDetails />
    </div>
  )
}

export default Show;